import { render, staticRenderFns } from "./ModalAddExistingCriteria.vue?vue&type=template&id=9faf20fa&"
import script from "./ModalAddExistingCriteria.vue?vue&type=script&lang=js&"
export * from "./ModalAddExistingCriteria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports